import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

export function metDetailsConfig(): PageConfig[] {
  const aeKao = ["Āe", "Kāo"];

  return [
    {
      name: "metIntro",
      title: "Māori Education Trust",
      elements: [
        {
          type: "html",
          html: `
            Rangitāne o Wairau partners with the Māori Education Trust, who
            provide additional pūtea to our successful applicants. As part of
            the Māori Education Trust criteria, all applicants must answer the
            following set of questions provided by MET. The answers to the
            following two questions do not affect the outcome of your
            application and are for data gathering purposes only.
          `,
        },
      ],
    },
    {
      name: "metReo",
      title: "Te Reo Māori",
      questions: [
        {
          name: "teReoWant",
          title:
            "Kei te hiahia au ki te ako i te reo Māori - I want to learn to reo Māori",
          type: "radiogroup",
          choices: aeKao,
          isRequired: true,
        },
        {
          name: "teReoLearn",
          title: "Kei te ako au i te reo Māori - I am learning te reo Māori",
          type: "radiogroup",
          choices: aeKao,
          isRequired: true,
        },
        {
          name: "teReoFamiliar",
          title:
            "Kei te āhua mōhio au i te reo Māori - I am familiar with te reo Māori",
          type: "radiogroup",
          choices: aeKao,
          isRequired: true,
        },
        {
          name: "teReoConfident",
          title:
            "Kei te maia au ki te reo Māori - I am confident in te reo Māori",
          type: "radiogroup",
          choices: aeKao,
          isRequired: true,
        },
        {
          name: "teReoGrew",
          title: "I tipu ake au i te reo Māori - I grew up in te reo Māori",
          type: "radiogroup",
          choices: aeKao,
          isRequired: true,
        },
        {
          name: "teReoDaily",
          title:
            "Kei te kōrerotia te reo i a rā, i a rā - Daily language is spoken in te reo Māori.",
          type: "radiogroup",
          choices: aeKao,
          isRequired: true,
        },
        {
          name: "teReoSchool",
          title:
            "Ka tuhia aku mahi whakamātautau i te reo Māori - I write my schoolwork in te reo Māori",
          type: "radiogroup",
          choices: aeKao,
          isRequired: true,
        },
        {
          name: "teReoBilingual",
          title:
            "E tautoko i nga reo korua engari e marama ana au ki te mana o te reo Māori - I believe in bilingualism where te reo Māori is valued and acknowledged",
          type: "radiogroup",
          choices: aeKao,
          isRequired: true,
        },
      ],
    },
    {
      name: "korowai",
      title:
        "Korowai Māori - Do you whakapapa to more than one marae, hapū, iwi?",
      questions: [
        {
          name: "korowai",
          title: "Marae",
          type: "text",
        },
        {
          name: "hapū",
          title: "Hapū",
          type: "text",
        },
        {
          name: "iwi",
          title: "Iwi",
          type: "text",
        },
      ],
    },
  ];
}
